import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createForm } from '../../store/formBuilder';
import Card from '../../components/ui/card';
import Button from '../../components/ui/button';
import Input from '../../components/ui/input';
import Label from '../../components/ui/label';
import { FiArrowLeft, FiPlus } from 'react-icons/fi';

const FormBuilderCreate = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const token = useSelector((state) => state.admin.token);

	const [formData, setFormData] = useState({
		name: '',
		description: '',
		category: '',
		is_active: true,
	});

	const [error, setError] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		let newValue = type === 'checkbox' ? checked : value;

		setFormData({
			...formData,
			[name]: newValue,
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setIsSubmitting(true);

		try {
			const result = await dispatch(
				createForm({
					formData,
					token,
				})
			).unwrap();

			if (result.form && result.form.id) {
				history.push(`/admin/form-builder/edit/${result.form.id}`);
			} else {
				setError('Form was created but no ID was returned');
			}
		} catch (error) {
			setError(error.message || 'Error creating form');
		} finally {
			setIsSubmitting(false);
		}
	};

	// Handle back navigation - don't save scroll position here
	// The scroll position was already saved when we left the list page
	const handleBackToList = () => {
		history.push('/admin/form-builder');
	};

	return (
		<div className='container mx-auto px-4 py-8'>
			<div className='flex items-center mb-6'>
				<button
					onClick={handleBackToList}
					className='mr-4 p-2 hover:bg-gray-100 rounded'>
					<FiArrowLeft className='text-gray-500' />
				</button>
				<h1 className='text-2xl font-bold text-gray-900'>Create New Form</h1>
			</div>

			{error && (
				<div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4'>
					{error}
				</div>
			)}

			<Card>
				<Card.Header>
					<h2 className='text-xl font-semibold'>Form Details</h2>
					<p className='text-sm text-gray-500'>
						Enter the basic details for your new form
					</p>
				</Card.Header>
				<Card.Content>
					<form onSubmit={handleSubmit} className='space-y-6'>
						<div>
							<Label htmlFor='name' className='required'>
								Form Name
							</Label>
							<Input
								id='name'
								name='name'
								value={formData.name}
								onChange={handleInputChange}
								placeholder='Enter form name'
								required
							/>
						</div>

						<div>
							<Label htmlFor='description'>Description</Label>
							<textarea
								id='description'
								name='description'
								value={formData.description}
								onChange={handleInputChange}
								placeholder='Enter form description'
								rows={3}
								className='w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-400'
							/>
						</div>

						<div>
							<Label htmlFor='category'>Category</Label>
							<Input
								id='category'
								name='category'
								value={formData.category}
								onChange={handleInputChange}
								placeholder='Enter form category'
							/>
							<p className='text-sm text-gray-500 mt-1'>
								Used to organize and group similar forms
							</p>
						</div>


						<div className='flex items-center space-x-2'>
							<input
								type='checkbox'
								id='is_active'
								name='is_active'
								checked={formData.is_active}
								onChange={handleInputChange}
								className='h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded'
							/>
							<Label htmlFor='is_active'>Active</Label>
						</div>

						<div className='flex justify-end space-x-4'>
							<Button
								type='button'
								variant='outline'
								onClick={handleBackToList}>
								Cancel
							</Button>
							<Button
								type='submit'
								disabled={isSubmitting}
								className='flex items-center'>
								<FiPlus className='mr-2' />
								{isSubmitting ? 'Creating...' : 'Create Form'}
							</Button>
						</div>
					</form>
				</Card.Content>
			</Card>
		</div>
	);
};

export default FormBuilderCreate;
